export const MIN_HR_VALUE = 41;
export const MAX_HR_VALUE = 159;
export const MIN_RR_VALUE = 6;
export const MAX_RR_VALUE = 39;
